<script setup lang="ts">

import { ref } from 'vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import ComboCard from '@/components/ComboCard.vue'
import { useDailyCombo } from '@/composables/game/daily'
import DailyPrizeBox from '@/components/DailyPrizeBox.vue'
import InfoCircleIcon from '@/components/icons/InfoCircleIcon.vue'
import { T, useTranslate } from '@tolgee/vue'
import Clock3Icon from '@/components/Clock3Icon.vue'

const showInfoModal = ref(false)

const {
  dailyComboTime,
  foundComboCards,
  isComboCardDone,
  isDailyComboDone,
  dailyComboRewardAmount,
} = useDailyCombo()

const { t } = useTranslate()

function tooltipContent(comboNumber: number) {
  return isComboCardDone(comboNumber) ? t.value('daily_combo.you_own', 'You own this card') : t.value('daily_combo.find_card', `Find the combo card\nbelow and pump it up`)
}

</script>

<template>
  <div class="flex flex-col bounce-in-right p-2 rounded-3xl bg-dark-bottom-layer border border-dark-top-most-layer">
    <div class="flex items-center gap-x-2 h-[34px] mb-2">
      <DailyPrizeBox
        class="flex-1"
        :title="$t('daily_combo.title', 'Daily combo')"
        :prize="dailyComboRewardAmount"
        :is-done="isDailyComboDone"
      />
      <div
        class="flex rounded-[30px] items-center px-2.5 bg-dark-top-layer backdrop-blur-[2px] py-[3px]"
      >
        <Clock3Icon class="w-4 h-4 min-w-[16px] text-white mr-1" />
        <span class="text-base font-medium -tracking-[0.32px] mr-1">{{ dailyComboTime }}</span>
        <InfoCircleIcon
          class="w-4 h-4 min-w-[16px] text-white/[.38]"
          @click="showInfoModal = true"
        />
      </div>
    </div>
    <div class="flex items-center justify-between gap-x-2">
      <ComboCard
        :key="i"
        v-for="i in [0, 1, 2]"
        v-tooltip="{content: tooltipContent(i + 1)}"
        class="flex-1"
        :completed="isComboCardDone(i + 1)"
        :title="$t(foundComboCards[i] ? $t(`card.${foundComboCards[i].id}.name`, foundComboCards[i].name) : '')"
        :image-path="foundComboCards[i]?.imageUrl"
      />
    </div>

    <TheBottomSheet
      :show="showInfoModal"
      content-class="pt-[30px]"
      @hide="showInfoModal = false"
    >
      <div class="flex flex-col items-center">
        <img
          class="w-auto h-[120px] object-cover"
          src="@/assets/images/question-mark.png"
          alt="question"
        >
        <div class="mt-6 text-2xl  -tracking-[0.48px] font-bold text-light-white">
          <div class="mt-6 text-2xl font-bold text-center -tracking-[0.48px] text-light-white uppercase">
            <T
              key-name="daily_combo.info.find_3_card"
              default-value="Find 3 combo cards"
            />
          </div>
          <div class="text-white/60 text-base font-medium text-center">
            <T
              key-name="daily_combo.info.upgrade_for_prize"
              default-value="Upgrade them to get a prize!"
            />
            <BaseButton
              class="mt-8 w-full"
              @click="showInfoModal = false"
            >
              <T
                key-name="daily_combo.info.button_cta"
                default-value="I hope I’m lucky"
              />
            </BaseButton>
          </div>
        </div>
      </div>
    </TheBottomSheet>
  </div>
</template>

<style scoped>

</style>
